// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DKLCT","top":"styles_top__WQlSA","left":"styles_left__2LGer","description":"styles_description__365Yd"};